module.exports = __webpack_public_path__ + "off_ramp_slight_left.svg?a79674b5443acfa9a7cd2bf362d2f181";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/off_ramp_slight_left.svg
// module id = 198
// module chunks = 0